import { render } from "./SimpleButton.vue?vue&type=template&id=470db4f2"
import script from "./SimpleButton.vue?vue&type=script&lang=js"
export * from "./SimpleButton.vue?vue&type=script&lang=js"
script.render = render

export default script